// @owners { team: patient-health }
import { InputSelect } from '@alto/design-system';
import React from 'react';
import { RELATIONSHIP_OPTIONS } from '~shared/constants';
import { possessiveName } from '~shared/helpers/string';

type Props = {
  error?: string;
  familyMemberName?: string;
  onChange: (value: string) => void;
  value: string;
};

export const InsuranceRelationshipInputSelect = ({ error, familyMemberName, onChange, value }: Props) => {
  const caption =
    familyMemberName !== undefined
      ? `${possessiveName(familyMemberName) || 'Family member’s'} relationship to the primary benefit holder`
      : 'Your relationship to the primary benefit holder';

  return (
    <InputSelect
      caption={caption}
      description={caption}
      error={error}
      label="Relationship"
      leftIcon="people"
      modalTitle="Select relationship"
      onValueChange={onChange}
      options={RELATIONSHIP_OPTIONS}
      placeholder="Self, Spouse, Child, etc."
      required
      value={value}
    />
  );
};
